import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkStatus, AuthError, composeAuth } from "../../helpers/utils";
import { logoutUser } from "./account";
import querystring from "query-string";

export const getActivityTemplateByInstitutionId = createAsyncThunk(
  "activity/getActivityTemplateByInstitutionId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/activity/activtiy_templates/intstituion/${payload?.institutionId}/getActivtyTempByIns`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
export const getActivitiesByInstitutionId = createAsyncThunk(
  "activity/getActivitiesByInstitutionId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/activity/institution/${payload?.institutionId}/get_by_id`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getActivitiesByWaveId = createAsyncThunk(
  "activity/getActivitiesByWaveId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/activity/institution/${payload?.institutionId}/module/${payload?.moduleId}/getByModuleAcivty`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const addActivity = createAsyncThunk(
  "activity/addActivity",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/activity/add_activity`;
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(payload?.requestBody),
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGhostLogs = createAsyncThunk(
  "activity/getGhostLogs",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + (payload?.isUser
        ? `/api/goals/institution/${payload?.institutionId}/generate_ghost_goal?${querystring.stringify({
        tag_ids: payload?.tag_ids,
      })}&offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`
        :
        `/api/goals/institution/${payload?.institutionId}/generate_ghost_goal/all?${querystring.stringify({
        tag_ids: payload?.tag_ids,
      })}&offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`);
      const res = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(payload?.body),
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        signal: thunkApi.signal,
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const deleteActivityByActivityId = createAsyncThunk(
  "activity/deleteActivityByActivityId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/activity/${payload?.activityId}`;
      const res = await fetch(url, {
        method: "DELETE",
        body: JSON.stringify(payload?.requestBody),
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const editActivityById = createAsyncThunk(
  "activity/editActivityById",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/activity/edit_activty/${payload?.id}`;
      const res = await fetch(url, {
        method: "PATCH",
        body: JSON.stringify(payload?.requestBody),
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
export const addWavesFromGoalsList = createAsyncThunk(
  "activity/addWavesFromGoalsList",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/institution/${payload?.institutionId}/create_wave`;
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(payload?.requestBody),
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const createLogsFromGoals = createAsyncThunk(
  "activity/createLogsFromGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/institution/${payload?.institutionId}/create_logs_from_goals`;
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(payload?.requestBody),
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const createLogsFromLocations = createAsyncThunk(
  "activity/createLogsFromLocations",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/institution/${payload?.institutionId}/create_logs_from_locations`;
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(payload?.requestBody),
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const addWavesFromLocations = createAsyncThunk(
  "activity/addWavesFromLocations",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/locations/institution/${payload?.institutionId}/create_wave`;
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(payload?.requestBody),
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
